import React from 'react';
import { ShieldAlert } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-noir-bg relative border-b border-noir-border flex justify-center" data-id="element-129">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-xl relative z-10" data-id="element-130">
        {/* Offer Card */}
        <div className="bg-noir-card border border-noir-border rounded-sm p-8 md:p-12 text-center shadow-[0_0_40px_rgba(61,0,0,0.4)] relative overflow-hidden" data-id="element-131">
          {/* Top Accent Line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-noir-alert" data-id="element-132"></div>

          <div className="inline-flex items-center justify-center w-16 h-16 bg-noir-bg border border-noir-border mb-8 rounded-sm" data-id="element-133">
            <ShieldAlert className="w-8 h-8 text-noir-alert" data-id="element-134" />
          </div>

          <h2 className="text-3xl md:text-4xl font-mono font-bold text-noir-text mb-4 uppercase" data-id="element-135">
            Acceso Autorizado
          </h2>

          <p className="text-base text-noir-muted mb-8 max-w-sm mx-auto" data-id="element-136">
            Recupera la complicidad de tu relación. Obtén el sistema completo de
            "Expediente Pareja" hoy.
          </p>

          {/* Mockup Image */}
          <div className="relative overflow-hidden border border-noir-border bg-noir-bg mb-10 mx-auto max-w-sm shadow-[0_0_20px_rgba(61,0,0,0.2)] rounded-sm group" data-id="element-137">
            <div className="absolute inset-0 bg-noir-crimson/10 mix-blend-overlay z-10 pointer-events-none transition-opacity duration-500 group-hover:opacity-30" data-id="element-138"></div>
            <img src="https://cdn.magicpatterns.com/uploads/idFHUeVM8Q9vh4XP46qFkP/iPad_Pro_displaying_202603260219.jpg" alt="Expediente Pareja en iPad" className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105 grayscale-[20%] contrast-110" data-id="element-139" />
            {/* Forensic UI Overlays */}
            <div className="absolute top-2 left-2 w-3 h-3 border-t border-l border-noir-alert z-20" data-id="element-140"></div>
            <div className="absolute top-2 right-2 w-3 h-3 border-t border-r border-noir-alert z-20" data-id="element-141"></div>
            <div className="absolute bottom-2 left-2 w-3 h-3 border-b border-l border-noir-alert z-20" data-id="element-142"></div>
            <div className="absolute bottom-2 right-2 w-3 h-3 border-b border-r border-noir-alert z-20" data-id="element-143"></div>
          </div>

          <div className="mb-10 relative" data-id="element-144">
            <div className="absolute -top-4 -right-4 bg-noir-alert text-white text-xs font-bold px-3 py-1 rounded-sm transform rotate-12 shadow-lg z-10 font-mono tracking-wider" data-id="element-145">
              68% DTO
            </div>
            <p className="text-xs text-noir-alert font-bold tracking-widest uppercase mb-2 font-mono" data-id="element-146">
              Precio Especial de Lanzamiento
            </p>

            <div className="flex items-center justify-center space-x-3 mb-1" data-id="element-147">
              <span className="text-xl text-noir-muted line-through font-mono opacity-70" data-id="element-148">
                $68.400
              </span>
            </div>

            <div className="flex items-center justify-center font-mono" data-id="element-149">
              <span className="text-6xl font-bold text-noir-text" data-id="element-150">$21.900</span>
              <span className="text-xl text-noir-muted ml-2 mt-4" data-id="element-151">COP</span>
            </div>
          </div>

          <div className="space-y-4" data-id="element-152">
            <button id="final-cta" className="w-full flex items-center justify-center px-8 py-5 text-lg font-bold text-white transition-all duration-200 bg-noir-alert border border-transparent rounded-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-noir-alert focus:ring-offset-noir-card uppercase tracking-widest shadow-[0_0_15px_rgba(200,16,46,0.3)]" data-id="element-153">
              Descargar Expediente
            </button>

            <div className="flex items-center justify-center text-xs text-noir-muted font-mono uppercase tracking-wider" data-id="element-154">
              <span className="w-2 h-2 bg-green-600 rounded-sm mr-2" data-id="element-155"></span>
              Acceso Inmediato Seguro
            </div>

            {/* Payment Methods */}
            <div className="pt-6 mt-6 border-t border-noir-border/50" data-id="element-156">
              <div className="flex flex-wrap justify-center gap-2" data-id="element-157">
                <div className="flex items-center px-3 py-1.5 bg-noir-bg border border-noir-border rounded-sm text-xs text-noir-muted" data-id="element-158">
                  <svg className="w-3 h-3 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-159">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" data-id="element-160" />
                  </svg>
                  Débito / Crédito
                </div>
                <div className="flex items-center px-3 py-1.5 bg-noir-bg border border-noir-border rounded-sm text-xs text-noir-muted italic font-bold" data-id="element-161">
                  pse
                </div>
                <div className="flex items-center px-3 py-1.5 bg-noir-bg border border-noir-border rounded-sm text-xs text-noir-muted font-bold" data-id="element-162">
                  Nequi
                </div>
                <div className="flex items-center px-3 py-1.5 bg-noir-bg border border-noir-border rounded-sm text-xs text-noir-muted font-bold" data-id="element-163">
                  <svg className="w-3 h-3 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-164">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-165" />
                  </svg>
                  Bancolombia
                </div>
                <div className="flex items-center px-3 py-1.5 bg-noir-bg border border-noir-border rounded-sm text-xs text-noir-muted font-bold" data-id="element-166">
                  efecty
                </div>
                <div className="flex items-center px-3 py-1.5 bg-noir-bg border border-noir-border rounded-sm text-xs text-noir-muted italic font-bold" data-id="element-167">
                  PayPal
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}